module.exports = __webpack_public_path__ + "img/1-en.a60df373.png";